import { defineStore } from 'pinia'
import type { ModalStatus } from '@/types'
import type { SizeKey } from '@/types/tailwind'
import { markRaw, type Component } from 'vue'
import ModalLoading from '@/components/modal/ModalLoading.vue'

let resolver: ((value: boolean) => void) | null = null

export const useModalStore = defineStore('modal', {
  state: () => ({
    show: false as boolean,
    status: 'none' as ModalStatus,
    text: '',
    title: '',
    component: null as Component | null, // Tambahan
    componentProps: {} as Record<string, unknown>,
    isConfirmed: false as boolean,
    sendingData: false,
    disableBackgroundClose: false,
    modalWidth: null as SizeKey | null,
  }),
  actions: {
    showModal(
      status: ModalStatus | undefined = 'none',
      text: string | undefined = '',
      title: string | undefined = '',
      component: Component | null = null,
      componentProps: Record<string, unknown> = {},
      disableBackgroundClose?: boolean,
      width?: SizeKey,
    ) {
      // jika status-nya show hilangkan dahulu
      if (this.show) this.closeModal()

      // atur status
      this.status = status
      this.text = text
      this.title = title
      this.component = component ? markRaw(component) : null
      this.componentProps = componentProps
      this.disableBackgroundClose = disableBackgroundClose === true
      this.modalWidth = width ?? null

      // munculkan modal
      this.show = true
    },

    confirmModalWithMessage(
      text: string,
      title: string = 'Konfirmasi',
      disableBackgroundClose?: boolean,
    ): Promise<boolean> {
      this.showModal('confirm', text, title, undefined, undefined, disableBackgroundClose)
      return new Promise((resolve) => {
        resolver = resolve
      })
    },

    confirmModal() {
      this.isConfirmed = true
      this.show = false
      this.disableBackgroundClose = false
      resolver?.(true)
      resolver = null
    },

    cancelModal() {
      this.isConfirmed = false
      this.show = false
      this.disableBackgroundClose = false
      resolver?.(false)
      resolver = null
    },

    closeModal() {
      // set ke default value lagi
      this.status = 'none'
      this.text = ''
      this.title = ''
      this.component = null
      this.componentProps = {}
      this.isConfirmed = false
      this.disableBackgroundClose = false

      // tutup modal
      this.show = false
      resolver = null
    },

    setSendingData(val: boolean) {
      this.sendingData = val
    },

    showLoading(iconName?: string, animation?: string) {
      this.showModal('none', '', '', ModalLoading, { iconName, animation }, true)
    },
  },
})
